module.exports = __webpack_public_path__ + "b22e97ba3b938048bc9c9c60f8da5ef9.jpg";